<template>
  <div id="report" class="animated fadeIn h-100">
    <div id="Loader" v-if="LoadYn">
      <div class="spinner-bar">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <b-card
      class="h-100 default-border1"
      body-class="h-100 p-0"
      header-tag="header"
    >
      <h6 slot="header">보고서</h6>
      <div class="searchBox p15">
        <div class="searchRows">
          <div class="searchRow">
            <div class="search-item">
              <label>레포트</label>
              <vue-select
                class="select-container w250"
                style="margin-right: 10px"
                :reduce="(a) => a.value"
                :options="search.reportTypeOptions"
                label="text"
                :clearable="false"
                v-model="search.reportType"
                required
              ></vue-select>
            </div>
            <div class="search-item">
              <label>프로젝트</label>
              <vue-select
                class="select-container w200"
                v-model="search.projectid"
                :options="search.projectOptions"
                @input="getStidList"
                :reduce="(a) => a.value"
                label="text"
                :clearable="false"
                required
              ></vue-select>
            </div>
            <div class="search-item">
              <label>구조물</label>
              <vue-select
                class="select-container w200"
                v-model="search.stid"
                :options="search.stidOptions"
                @input="changeStid"
                :reduce="(a) => a.value"
                label="text"
                :clearable="false"
                required
              ></vue-select>
            </div>
            <div v-if="search.reportType === 'weekly'" class="search-item">
              <label>센서타입</label>
              <b-form-select
                v-model="search.sensorType"
                :options="search.sensorTypeOptions"
                required
              ></b-form-select>
            </div>
          </div>
          <div class="searchRow">
            <div class="search-item">
              <label>기간</label>
              <div class="search-item-group">
                <b-form-input
                  type="date"
                  v-model="search.startDate"
                  :max="search.endDate"
                  required
                ></b-form-input>
                <label>~</label>
                <b-form-input
                  type="date"
                  v-model="search.endDate"
                  :min="search.startDate"
                  required
                ></b-form-input>
              </div>
            </div>
            <div class="search-item">
              <label>이상치 처리</label>
              <div class="search-item-group">
                <input
                  type="checkbox"
                  v-model="search.isScreenOutliers"
                  :checked="search.isScreenOutliers"
                  style="width: 20px; margin-right: 10px"
                />
                <b-form-input
                  v-model="search.outlierThreshold"
                  style="width: 60px"
                  :disabled="!search.isScreenOutliers"
                ></b-form-input>
              </div>
            </div>
            <div v-if="search.reportType === 'weekly'" class="search-item">
              <label>로고 숨김</label>
              <div class="search-item-group">
                <input
                  type="checkbox"
                  v-model="search.hideLogo"
                  :checked="search.hideLogo"
                  style="width: 20px; margin-right: 10px"
                />
              </div>
            </div>
          </div>
        </div>
        <div style="height: 30px">
          <b-button
            class="searchBtn"
            @click="searchData"
            :disabled="search.stid == null"
            style="white-space: nowrap"
            >조회
          </b-button>
          <b-button class="excelBtn" @click="downloadPdf">PDF</b-button>
        </div>
      </div>
      <div class="body" v-if="search.reportType === 'weekly'">
        <div class="weeklyReportDiv">
          <div class="a4" id="pdfHeaderDiv">
            <div
              style="
                display: flex;
                flex-direction: column;
                border: 3px solid #888;
                padding: 5px 5px 0;
              "
            >
              <div class="header">
                <b-img
                  v-if="!search.hideLogo"
                  class="logo"
                  src="static/img/logo_tp1.png"
                  width="60"
                ></b-img>
                <div
                  style="
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  [
                  <label class="highlight-text-blue-color">주간</label>
                  ]
                  <label>계측 현황 보고_</label>
                  <label class="highlight-text-blue-color">{{
                    summary.stname
                  }}</label>
                </div>
                <label class="date">{{ header.date }}</label>
              </div>
              <label
                style="
                  align-self: center;
                  font-size: 10pt;
                  font-weight: 500;
                  text-decoration: underline;
                "
                >[ {{ header.startDate }} ~ {{ header.endDate }} ]</label
              >
            </div>

            <div
              style="
                width: 100%;
                margin-top: 5px;
                border-bottom: 3px double #999;
              "
            ></div>
          </div>

          <div class="a4" id="pdfBodyDiv1">
            <div class="title">1. 개요</div>
            <div class="content">
              <div>
                <label class="key ml30">&bull; 계측 관리 명:</label>
                <label class="highlight-text-blue-color">{{
                  summary.projectname
                }}</label>
              </div>
              <div>
                <label class="key ml30">&bull; 구조물:</label>
                <label class="highlight-text-blue-color">{{
                  summary.stname
                }}</label>
                <!-- <label class="highlight-text-black-color">구조물 이름</label> -->
                <label v-if="summary.staddr" class="highlight-text-blue-color"
                  >/ {{ summary.staddr }}
                </label>
              </div>
              <div>
                <label class="key ml30">&bull; 계측 기간:</label>
                <label>{{ summary.regdate }}</label>
              </div>
            </div>

            <div class="title">
              2. 센서 정보
              <span v-if="isSensorTypeDynamic">[가속도 센서]</span>
            </div>
            <div class="content">
              <ag-grid-vue
                class="ag-theme-balham grid"
                :domLayout="domLayout"
                :gridOptions="sensorGridOptions"
              ></ag-grid-vue>
            </div>

            <div class="title">3. 데이터 현황</div>
            <div class="content">
              <div>
                <label class="key ml30">&bull; 누적 현황(</label>
                <label>{{ summary.regdate }}</label>
                <label class="key">)</label>
              </div>
              <ag-grid-vue
                class="ag-theme-balham grid"
                :domLayout="domLayout"
                :gridOptions="cumulativeStatusGridOptions"
              ></ag-grid-vue>
            </div>
          </div>

          <div class="a4" id="pdfBodyDiv2">
            <div class="content">
              <div>
                <label class="key ml30">&bull; 현재 현황(</label>
                <label>{{ header.startDate }} ~ {{ header.endDate }}</label>
                <label class="key">)</label>
              </div>
              <div
                id="svChart"
                class="graph chart"
                style="margin-bottom: 10px"
                v-if="!isSensorTypeDynamic"
              ></div>
              <div
                id="analChart"
                class="graph chart"
                style="margin-bottom: 10px"
                v-if="isSensorTypeDynamic"
              ></div>
              <div
                id="raweChart"
                class="graph chart"
                style="margin-bottom: 10px"
                v-if="isSensorTypeDynamic"
              ></div>
              <div id="fileChart" class="graph chart"></div>
            </div>
          </div>
          <div v-if="isSensorTypeDynamic">
            <div
              class="a4"
              :id="'pdfBodyDiv3-1-' + index + '_dynamic'"
              v-for="(item, index) in dynamicMeasurementDataAnalysisDatas"
              v-bind:key="index"
            >
              <div class="title" v-if="index === 0">4. 계측 데이터 분석</div>

              <div class="content">
                <div v-if="index === 0">
                  <label class="key ml30">1) 통계 데이터(P-P value, RMS)</label>
                </div>
                <div>
                  <label class="key ml45">&bull; {{ item.chartTitle }}</label>
                </div>
                <div>
                  <label class="key ml55">P-P 값 이력</label>
                </div>
                <div
                  :id="
                    item.deviceid +
                    (item.channel ? '_' + item.channel : '') +
                    '_ptp_chart'
                  "
                  class="graph chart"
                  style="margin-bottom: 10px"
                  v-if="item.chartData"
                ></div>
                <div>
                  <label class="key ml55">RMS 값 이력</label>
                </div>
                <div
                  :id="
                    item.deviceid +
                    (item.channel ? '_' + item.channel : '') +
                    '_rms_chart'
                  "
                  class="graph chart"
                  style="margin-bottom: 10px"
                  v-if="item.chartData"
                ></div>
              </div>
            </div>
          </div>
          <div
            class="a4"
            id="pdfBodyDiv3-2_dynamic"
            :style="isSensorTypeDynamic ? 'display: block;' : 'display: none;'"
          >
            <div
              class="content"
              :style="
                isSensorTypeDynamic ? 'display: block;' : 'display: none;'
              "
            >
              <div>
                <label class="key ml30">2) 주파수 분석</label>
              </div>
              <div>
                <label class="key ml45">&bull; AvgFFT 결과[file 결과]</label>
              </div>
              <div
                id="fftAvgChart"
                class="graph chart"
                style="margin-bottom: 10px"
              ></div>
              <div
                id="fftPeakChart"
                class="graph chart"
                style="margin-bottom: 10px"
              ></div>
              <ag-grid-vue
                class="ag-theme-balham grid"
                style="margin-bottom: 10px"
                :domLayout="domLayout"
                :gridOptions="fftClStatGridOptions"
              ></ag-grid-vue>
              <div
                id="ssiFreqChart"
                class="graph chart"
                style="margin-bottom: 10px"
              ></div>
              <ag-grid-vue
                class="ag-theme-balham grid"
                style="margin-bottom: 10px"
                :domLayout="domLayout"
                :gridOptions="ssiClStatGridOptions"
              ></ag-grid-vue>
            </div>
          </div>

          <div
            class="a4"
            id="pdfBodyDiv3-3_dynamic"
            :style="isSensorTypeDynamic ? 'display: block;' : 'display: none;'"
          >
            <div class="content" v-if="isSensorTypeDynamic">
              <div>
                <label class="key ml30">3) Impact factor(충격계수) 추정</label>
              </div>
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  height: 250px;
                  margin-bottom: 10px;
                "
              >
                <div id="ssiIfChart" class="graph chart" style="flex: 1"></div>
                <div id="ssiIfHist" class="graph chart" style="flex: 1"></div>
              </div>
            </div>
          </div>

          <div
            class="a4"
            id="pdfBodyDiv3-1_static"
            :style="!isSensorTypeDynamic ? 'display: block;' : 'display: none;'"
          >
            <div class="title" v-if="!isSensorTypeDynamic">
              4. 계측 데이터 분석
            </div>
            <div
              class="content"
              :style="
                !isSensorTypeDynamic ? 'display: block;' : 'display: none;'
              "
            >
              <ag-grid-vue
                class="ag-theme-balham grid"
                :domLayout="domLayout"
                :gridOptions="staticMeasurementDataAnalysisGridOptions"
              ></ag-grid-vue>
            </div>
          </div>
          <div v-if="!isSensorTypeDynamic">
            <div
              class="a4"
              :id="'pdfBodyDiv3-2-' + rootIndex + '_static'"
              v-for="(
                items, rootIndex
              ) in staticMeasurementDataAnalysisCustomerDatas"
              v-bind:key="rootIndex"
            >
              <div class="title" v-if="rootIndex === 0">
                5. 계측 데이터 plot
              </div>
              <div
                class="content"
                v-for="(item, index) in items"
                v-bind:key="index"
              >
                <div>
                  <label class="key ml30">&bull; {{ item.chartTitle }}</label>
                </div>
                <div
                  :id="item.deviceid + '_' + item.channel + '_chart'"
                  class="graph chart"
                  style="margin-bottom: 10px"
                  v-if="item.chartData"
                ></div>
              </div>
            </div>
          </div>
          <div class="a4" id="pdfBodyDiv4">
            <div class="title">
              <span v-if="isSensorTypeDynamic">5</span>
              <span v-else>6</span>
              . 현장 점검 및 조치 사항
            </div>
            <div class="content">
              <ag-grid-vue
                v-if="isStaticInspectionAndAction"
                class="ag-theme-balham grid"
                :domLayout="domLayout"
                :gridOptions="staticInspectionAndActionGridOptions"
              ></ag-grid-vue>
              <div v-else>
                <label class="key ml30">&bull;</label>
                <label class="highlight-text-blue-color">없음</label>
              </div>
            </div>

            <div class="title">
              <span v-if="isSensorTypeDynamic">6</span>
              <span v-else>7</span>
              . 최종 의견
            </div>
            <div class="content">
              <!-- pdf로 변환 시 textarea의 텍스트가 줄바꿈이 적용되지 않고 한줄로 나오는 현상때문에 div를 textarea 처럼 보이게 변경함 - kyj -->
              <!-- <textarea v-model="finalOpinion"></textarea> -->
              <!-- pdf로 변환 시 textarea의 텍스트가 줄바꿈이 적용되지 않고 한줄로 나오는 현상때문에 div를 textarea 처럼 보이게 변경함 - kyj -->

              <div class="customer-textarea" contenteditable>
                {{ finalOpinion }}
              </div>
            </div>
          </div>

          <div class="a4" id="pdfFooterDiv">
            <div v-if="!search.hideLogo" class="footer">
              <label>Smartcs.co.kr.</label>
              <label>TEL. 042-936-1831</label>
            </div>
            <div
              v-if="!search.hideLogo"
              style="width: 100%; border-bottom: 3px double #999"
            ></div>
            <div v-if="!search.hideLogo" class="footer">
              <label
                >Copyrightⓒ2008 by smartcs Co.,Ltd. All pictures cannot be
                copied without permission.</label
              >
            </div>
            <div
              class="footer"
              :class="{ 'justify-content-center': search.hideLogo }"
            >
              <b-img
                v-if="!search.hideLogo"
                src="static/img/pdf_footer_left.png"
              ></b-img>
              <label style="font-size: 10px"
                >{{ footer.page }} / {{ footer.totalPage }}</label
              >
              <b-img
                v-if="!search.hideLogo"
                src="static/img/pdf_footer_right.png"
              ></b-img>
            </div>
          </div>
        </div>
      </div>

      <div class="body" v-if="search.reportType === 'railMonthReport'">
        <div class="pdfViewDiv">
          <iframe
            id="pdfIframe"
            height="100%"
            width="100%"
            :src="pdfSrc"
            title="Main menu"
          ></iframe>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";
import html2canvas from "html2canvas";
import JsPDF from "jspdf";
import { AgGridVue } from "ag-grid-vue";
import chartUtil from "../common/chartUtil";
import utils from "../common/utils";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
var Plotly = require("plotly.js/dist/plotly.min.js");

export default {
  components: {
    AgGridVue,
    VueSelect,
  },
  computed: {
    ...mapGetters([
      "getUserId",
      "getUserAuth",
      "getAlertOptions",
      "getConfirmOptions",
      "getSelectedDataProjectid",
      "getSelectedDataStid",
      "getSelectedDataStartDate",
      "getSelectedDataEndDate",
      "getCenterBus",
    ]),
  },
  data() {
    return {
      search: {
        reportType: "weekly",
        reportTypeOptions: [
          { value: "weekly", text: "주간 계측 현황 보고서" },
          { value: "railMonthReport", text: "월간 보고서" },
        ],
        projectid: null,
        projectOptions: [{ value: null, text: "선택" }],
        stid: null,
        stidOptions: [{ value: null, text: "선택" }],
        sensorType: "dynamic",
        sensorTypeOptions: [
          { value: "dynamic", text: "동적" },
          { value: "static", text: "정적" },
        ],
        startDate: null,
        endDate: null,
        isScreenOutliers: false,
        outlierThreshold: 2,
        hideLogo: false,
      },
      isSensorTypeDynamic: true,
      header: {
        date: null,
        startDate: null,
        endDate: null,
      },
      footer: {
        page: 1,
        totalPage: 0,
      },
      summary: {
        projectname: null,
        stname: null,
        staddr: null,
        regdate: null,
      },
      sensorGridOptions: {
        columnDefs: null,
        rowData: [],
        localeText: { noRowsToShow: "조회 결과가 없습니다." },
        rowSelection: "single",
        toolPanelSuppressSideButtons: true,
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        },
        onRowDataChanged: (params) => {
          params.api.sizeColumnsToFit();
        },
        enableSorting: true,
        onRowClicked: (params) => {},
        onRowDoubleClicked: (params) => {},
        rowHeight: 35,
        headerHeight: 35,
      },
      cumulativeStatusGridOptions: {
        columnDefs: null,
        rowData: [],
        localeText: { noRowsToShow: "조회 결과가 없습니다." },
        rowSelection: "single",
        toolPanelSuppressSideButtons: true,
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        },
        onRowDataChanged: (params) => {
          params.api.sizeColumnsToFit();
        },
        enableSorting: true,
        onRowClicked: (params) => {},
        onRowDoubleClicked: (params) => {},
        rowHeight: 35,
        headerHeight: 35,
      },
      staticMeasurementDataAnalysisGridOptions: {
        columnDefs: null,
        rowData: [],
        localeText: { noRowsToShow: "조회 결과가 없습니다." },
        rowSelection: "single",
        toolPanelSuppressSideButtons: true,
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        },
        onRowDataChanged: (params) => {
          params.api.sizeColumnsToFit();
        },
        enableSorting: true,
        onRowClicked: (params) => {},
        onRowDoubleClicked: (params) => {},
        rowHeight: 35,
        headerHeight: 35,
      },
      fftClStatGridOptions: {
        columnDefs: null,
        rowData: [],
        localeText: { noRowsToShow: "조회 결과가 없습니다." },
        rowSelection: "single",
        toolPanelSuppressSideButtons: true,
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        },
        onRowDataChanged: (params) => {
          params.api.sizeColumnsToFit();
        },
        enableSorting: true,
        onRowClicked: (params) => {},
        onRowDoubleClicked: (params) => {},
        rowHeight: 35,
        headerHeight: 35,
      },
      ssiClStatGridOptions: {
        columnDefs: null,
        rowData: [],
        localeText: { noRowsToShow: "조회 결과가 없습니다." },
        rowSelection: "single",
        toolPanelSuppressSideButtons: true,
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        },
        onRowDataChanged: (params) => {
          params.api.sizeColumnsToFit();
        },
        enableSorting: true,
        onRowClicked: (params) => {},
        onRowDoubleClicked: (params) => {},
        rowHeight: 35,
        headerHeight: 35,
      },
      staticInspectionAndActionGridOptions: {
        columnDefs: null,
        rowData: [],
        localeText: { noRowsToShow: "조회 결과가 없습니다." },
        rowSelection: "single",
        toolPanelSuppressSideButtons: true,
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        },
        onRowDataChanged: (params) => {
          params.api.sizeColumnsToFit();
        },
        enableSorting: true,
        onRowClicked: (params) => {},
        onRowDoubleClicked: (params) => {},
        rowHeight: 35,
        headerHeight: 35,
      },
      isStaticInspectionAndAction: false,
      domLayout: "autoHeight",
      svChart: [
        {
          x: [],
          y: [],
          name: "Data Size",
          type: "scatter",
          mode: "lines+markers",
          line: {
            width: 2,
            color: "#009999",
          },
        },
        {
          x: [],
          y: [],
          name: "Data Count",
          type: "scatter",
          mode: "lines+markers",
          line: {
            width: 2,
            color: "#9999CC",
          },
          yaxis: "y2",
        },
      ],
      fileChart: [
        {
          x: [],
          y: [],
          name: "Data Size",
          type: "scatter",
          mode: "lines+markers",
          line: {
            width: 2,
            color: "#009999",
          },
        },
        {
          x: [],
          y: [],
          name: "Data Count",
          type: "scatter",
          mode: "lines+markers",
          line: {
            width: 2,
            color: "#9999CC",
          },
          yaxis: "y2",
        },
      ],
      raweChart: [
        {
          x: [],
          y: [],
          name: "Data Size",
          type: "scatter",
          mode: "lines+markers",
          line: {
            width: 2,
            color: "#009999",
          },
        },
        {
          x: [],
          y: [],
          name: "Data Count",
          type: "scatter",
          mode: "lines+markers",
          line: {
            width: 2,
            color: "#9999CC",
          },
          yaxis: "y2",
        },
      ],
      analChart: [
        {
          x: [],
          y: [],
          name: "Data Size",
          type: "scatter",
          mode: "lines+markers",
          line: {
            width: 2,
            color: "#009999",
          },
        },
        {
          x: [],
          y: [],
          name: "Data Count",
          type: "scatter",
          mode: "lines+markers",
          line: {
            width: 2,
            color: "#9999CC",
          },
          yaxis: "y2",
        },
      ],
      dynamicMeasurementDataAnalysisDatas: [],
      staticMeasurementDataAnalysisDatas: [],
      staticMeasurementDataAnalysisCustomerDatas: [],
      finalOpinion: "",
      pdf: {
        headerImgData: null,
        bodyImgDatas: [],
        footerImgData: null,
      },
      LoadYn: false,
      isFirstCall: true,

      // 월간 보고서
      pdfSrc: null,
      excelFileName: null,
      pdfFileName: null,
    };
  },
  created() {
    this.getProjectList();
  },
  beforeMount() {
    this.sensorGridOptions.columnDefs = [
      { headerName: "센서ID", field: "sensorId", width: 150 },
      { headerName: "센서 종류", field: "sensorTypeName", width: 120 },
      { headerName: "센서 이름", field: "sensoralias", width: 150 },
      { headerName: "시리얼 번호", field: "sn", width: 170 },
      { headerName: "설치 일자", field: "instldate", width: 150 },
      { headerName: "위치", field: "instldesc" },
    ];
    this.changeCumulativeStatusGridColDef(false);
  },
  mounted() {
    this.search.startDate = moment().add(-7, "day").format("YYYY-MM-DD");
    this.search.endDate = moment().format("YYYY-MM-DD");

    if (this.getSelectedDataStartDate) {
      this.search.startDate = this.getSelectedDataStartDate;
    }
    if (this.getSelectedDataEndDate) {
      this.search.endDate = this.getSelectedDataEndDate;
    }
  },
  methods: {
    ...mapMutations([
      "setAlertTitle",
      "setConfirmTitle",
      "setSelectedDataProjectid",
      "setSelectedDataStid",
      "setSelectedDataStartDate",
      "setSelectedDataEndDate",
    ]),
    getProjectList() {
      var reqBody = {};
      this.$http
        .post("/stat/getProjectList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].projectid,
                text: data[i].projectname,
              });
            }
            this.search.projectOptions = options;
            if (this.getSelectedDataProjectid) {
              this.search.projectid = this.getSelectedDataProjectid;
              this.getStidList();
            } else this.search.projectid = null;
          } else {
            this.setAlertTitle("프로젝트 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getStidList() {
      if (!this.search.projectid) {
        this.search.stidOptions = [{ value: null, text: "선택" }];
        this.search.stid = null;
        return;
      }
      var reqBody = {
        projectid: this.search.projectid,
      };
      this.$http
        .post("/sensor/getStidList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].stid,
                text: data[i].stname,
              });
            }
            this.search.stidOptions = options;
            if (this.isFirstCall) {
              if (this.getSelectedDataStid) {
                this.search.stid = this.getSelectedDataStid;
              } else this.search.stid = null;
            } else this.search.stid = null;
            this.isFirstCall = false;

            // this.search.stid = this.search.stidOptions[7].value
            // this.searchData()
          } else {
            this.setAlertTitle("구조물 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    changeStid() {
      if (this.search.reportType === "railMonthReport") {
        if (this.search.stid == "S_000457") {
          this.search.startDate = moment(this.search.endDate)
            .subtract(3, "month")
            .format("YYYY-MM-DD");
        } else {
          this.search.startDate = moment(this.search.endDate)
            .subtract(1, "month")
            .format("YYYY-MM-DD");
        }
      } else {
        this.search.startDate = moment(this.search.endDate)
          .subtract(1, "weeks")
          .format("YYYY-MM-DD");
      }
    },
    changeCumulativeStatusGridColDef(isUpdate) {
      if (this.isSensorTypeDynamic) {
        this.cumulativeStatusGridOptions.columnDefs = [
          { headerName: "센서ID", field: "sensorId", width: 100 },
          {
            headerName: "통계 데이터 DB",
            children: [
              {
                headerName: "데이터 용량(MB)",
                field: "analdatasize",
                width: 150,
              },
              { headerName: "데이터 개수", field: "analdatacnt", width: 150 },
            ],
          },
          {
            headerName: "이벤트 데이터",
            children: [
              {
                headerName: "데이터 용량(MB)",
                field: "rawedatacnt",
                width: 150,
              },
              { headerName: "데이터 개수", field: "rawedatasize", width: 150 },
            ],
          },
          {
            headerName: "데이터 파일",
            children: [
              { headerName: "파일 개수", field: "filedatacnt", width: 120 },
              {
                headerName: "파일 누적 용량(MB)",
                field: "filedatasize",
                width: 180,
              },
            ],
          },
        ];
      } else {
        this.cumulativeStatusGridOptions.columnDefs = [
          { headerName: "센서ID", field: "sensorId", width: 100 },
          {
            headerName: "S-V(센서 데이터 DB)",
            children: [
              {
                headerName: "데이터 용량(MB)",
                field: "svdatasize",
                width: 150,
              },
              { headerName: "데이터 개수", field: "svdatacnt", width: 150 },
            ],
          },
          {
            headerName: "데이터 파일",
            children: [
              { headerName: "파일 개수", field: "filedatacnt", width: 150 },
              {
                headerName: "파일 누적 용량(MB)",
                field: "filedatasize",
                width: 150,
              },
            ],
          },
        ];

        this.staticMeasurementDataAnalysisGridOptions.columnDefs = [
          { headerName: "센서ID", field: "sensorId", width: 100 },
          {
            headerName: "관리 임계치",
            children: [
              { headerName: "하한", field: "thrhigh", width: 150 },
              { headerName: "상한", field: "thrlow", width: 150 },
            ],
          },
          {
            headerName: "데이터 값",
            children: [
              { headerName: "최소(MIN)", field: "min", width: 150 },
              { headerName: "최대(MAX)", field: "max", width: 150 },
              { headerName: "평균(AVG)", field: "mean", width: 150 },
            ],
          },
          { headerName: "결과", field: "rsltNm", width: 90 },
        ];
      }

      if (isUpdate) {
        this.cumulativeStatusGridOptions.api.setColumnDefs(
          this.cumulativeStatusGridOptions.columnDefs
        );

        if (!this.isSensorTypeDynamic) {
          this.staticMeasurementDataAnalysisGridOptions.api.setColumnDefs(
            this.staticMeasurementDataAnalysisGridOptions.columnDefs
          );
        }
      }
    },
    initData() {
      this.header.date = null;
      this.header.startDate = null;
      this.header.endDate = null;

      this.footer.page = 1;
      this.footer.totalPage = 0;

      this.pdf.headerImgData = null;
      this.pdf.bodyImgData = [];
      this.pdf.footerImgData = null;

      this.summary.projectname = null;
      this.summary.stname = null;
      this.summary.staddr = null;
      this.summary.regdate = null;

      this.sensorGridOptions.api.setRowData([]);
      this.cumulativeStatusGridOptions.api.setRowData([]);
      this.isStaticInspectionAndAction = false;

      this.svChart[0].x = [];
      this.svChart[0].y = [];
      this.svChart[1].x = [];
      this.svChart[1].y = [];

      this.fileChart[0].x = [];
      this.fileChart[0].y = [];
      this.fileChart[1].x = [];
      this.fileChart[1].y = [];

      this.analChart[0].x = [];
      this.analChart[0].y = [];
      this.analChart[1].x = [];
      this.analChart[1].y = [];

      this.raweChart[0].x = [];
      this.raweChart[0].y = [];
      this.raweChart[1].x = [];
      this.raweChart[1].y = [];

      this.finalOpinion = "";

      if (this.isSensorTypeDynamic) {
        // Plotly.purge('analChart')
        // Plotly.purge('raweChart')
        this.dynamicMeasurementDataAnalysisDatas = [];
      } else {
        // Plotly.purge('svChart')
        // this.staticMeasurementDataAnalysisGridOptions.api.setRowData([])
        this.staticMeasurementDataAnalysisDatas = [];
        this.staticMeasurementDataAnalysisCustomerDatas = [];
      }
      Plotly.purge("fileChart");
    },
    searchData() {
      if (this.search.stid === null) return;
      this.LoadYn = true;

      if (this.search.reportType === "weekly") {
        this.createWeeklyReport();
      } else {
        this.createMonthlyReport();
      }
    },
    createWeeklyReport() {
      let startDate = moment(this.search.startDate).format("YYYYMMDD");
      let endDate = moment(this.search.endDate).format("YYYYMMDD");
      let reqBody = {
        stid: this.search.stid,
        sensorType: this.search.sensorType,
        startDate: startDate,
        endDate: endDate,
        startDashDate: this.search.startDate,
        endDashDate: this.search.endDate,
        isScreenOutliers: this.search.isScreenOutliers,
        outlierThreshold: this.search.outlierThreshold,
      };

      this.setSelectedDataProjectid(this.search.projectid);
      this.setSelectedDataStid(this.search.stid);
      this.setSelectedDataStartDate(this.search.startDate);
      this.setSelectedDataEndDate(this.search.endDate);

      this.isSensorTypeDynamic = this.search.sensorType === "dynamic";
      this.changeCumulativeStatusGridColDef(true);
      this.initData();
      this.getSummary(reqBody);
      this.getSensorList(reqBody);
      this.getCumulativeStatus(reqBody);
      this.getWeekChartStatus(reqBody);
      this.getInspectionAndAction(reqBody);

      if (this.isSensorTypeDynamic) {
        this.getAnalDataHist(reqBody);
      }

      this.header.date = moment(new Date()).format("YYYY-MM-DD");
      this.header.startDate = this.search.startDate;
      this.header.endDate = this.search.endDate;
    },
    async createMonthlyReport() {
      let reqBody = {
        reportType: this.search.reportType,
        reportTypeName: findOptionText(
          this.search.reportTypeOptions,
          this.search.reportType
        ),
        periodType: "temp",
        periodTypeName: "임시",
        projectid: this.search.projectid,
        projectname: findOptionText(
          this.search.projectOptions,
          this.search.projectid
        ),
        stid: this.search.stid,
        stname: findOptionText(this.search.stidOptions, this.search.stid),
        stdate: this.search.startDate,
        eddate: this.search.endDate,
      };

      await this.$http
        .post("/excelReport/createReportFile", reqBody, { timeout: 60000 * 30 })
        .then((res) => {
          this.LoadYn = false;
          if (res.data.resultyn === "Y") {
            this.excelFileName = res.data.data.excelFileName || null;

            let base64Pdf = res.data.data.base64Pdf;

            if (base64Pdf && base64Pdf.length > 0) {
              this.pdfFileName = res.data.data.pdfFileName;

              let binaryString = window.atob(base64Pdf);
              let binaryLen = binaryString.length;
              let bytes = new Uint8Array(binaryLen);
              for (let i = 0; i < binaryLen; i++) {
                let ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
              }
              let blob = new Blob([bytes], { type: "application/pdf" });
              let link = window.URL.createObjectURL(blob);
              this.pdfSrc = link;
            }
          } else {
            var errormsg =
              res.data.errormsg == undefined ? "" : res.data.errormsg;
            errormsg += "관리자에게 문의하세요.";
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk(errormsg, this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          this.LoadYn = false;
          console.error(err);
        });

      function findOptionText(options, value) {
        return options.find((option) => option.value === value).text;
      }
    },
    getSummary(reqBody) {
      this.$http
        .post("/report/getSummary", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            this.summary.projectname = data.projectname;
            this.summary.stname = data.stname;
            this.summary.staddr = data.staddr;
            this.summary.regdate = data.regdate;
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getSensorList(reqBody) {
      this.$http
        .post("/report/getSensorInfo", reqBody, { timeout: 30000 })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            this.sensorGridOptions.api.setRowData(res.data.data.data);

            if (this.isSensorTypeDynamic) {
              this.dynamicMeasurementDataAnalysisDatas = res.data.data.data;
              this.setDynamicMeasurementChart();
              this.finalOpinion = res.data.data.finalOpinion;
            } else {
              for (let i = 0; i < res.data.data.data.length; i += 2) {
                let customerDatas = [];
                customerDatas.push(res.data.data.data[i]);
                if (res.data.data.data[i + 1]) {
                  customerDatas.push(res.data.data.data[i + 1]);
                }

                this.staticMeasurementDataAnalysisCustomerDatas.push(
                  customerDatas
                );
              }
              this.staticMeasurementDataAnalysisDatas = res.data.data.data;
              this.setStaticMeasurementChart();
              this.finalOpinion = res.data.data.finalOpinion;
              this.staticMeasurementDataAnalysisGridOptions.api.setRowData(
                this.staticMeasurementDataAnalysisDatas
              );
            }
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
          this.LoadYn = false;
        })
        .catch((err) => {
          console.error(err);
          this.LoadYn = false;
        });
    },
    getCumulativeStatus(reqBody) {
      this.$http
        .post("/report/getCumulativeStatus", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            this.cumulativeStatusGridOptions.api.setRowData(res.data.data);
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getWeekChartStatus(reqBody) {
      this.$http
        .post("/report/getWeekChartStatus", reqBody, { timeout: 5 * 60 * 1000 })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            if (this.isSensorTypeDynamic) {
              res.data.data.anal.forEach((data) => {
                this.analChart[0].x.push(data.collecttime);
                this.analChart[1].x.push(data.collecttime);
                this.analChart[0].y.push(data.totaldatasize);
                this.analChart[1].y.push(data.totaldatacnt);
              });
              this.drawDualAxisLineChart("analChart", this.analChart, "Anal");

              res.data.data.rawe.forEach((data) => {
                this.raweChart[0].x.push(data.collecttime);
                this.raweChart[1].x.push(data.collecttime);
                this.raweChart[0].y.push(data.totaldatasize);
                this.raweChart[1].y.push(data.totaldatacnt);
              });
              this.drawDualAxisLineChart("raweChart", this.raweChart, "Rawe");
            } else {
              res.data.data.sv.forEach((data) => {
                this.svChart[0].x.push(data.collecttime);
                this.svChart[1].x.push(data.collecttime);
                this.svChart[0].y.push(data.totaldatasize);
                this.svChart[1].y.push(data.totaldatacnt);
              });
              this.drawDualAxisLineChart("svChart", this.svChart, "S-V");
            }

            res.data.data.file.forEach((data) => {
              this.fileChart[0].x.push(data.collecttime);
              this.fileChart[1].x.push(data.collecttime);
              this.fileChart[0].y.push(data.totaldatasize);
              this.fileChart[1].y.push(data.totaldatacnt);
            });
            this.drawDualAxisLineChart("fileChart", this.fileChart, "File");
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setStaticMeasurementChart() {
      if (
        this.staticMeasurementDataAnalysisDatas &&
        this.staticMeasurementDataAnalysisDatas.length > 0
      ) {
        setTimeout((x) => {
          this.staticMeasurementDataAnalysisDatas.forEach((data) => {
            let chartData = data.chartData;
            if (chartData) {
              let charId = data.deviceid + "_" + data.channel + "_chart";
              let tmpChart = [
                {
                  x: chartData.time,
                  y: chartData["s-v"],
                  name: "s-v",
                  type: "scatter",
                  mode: "lines",
                  line: {
                    width: 2,
                    color: "#009999",
                  },
                },
                {
                  x: chartData.time,
                  y: chartData.trend,
                  name: "trend",
                  type: "scatter",
                  mode: "lines",
                  line: {
                    width: 2,
                    color: "#9999CC",
                  },
                },
                {
                  x: chartData.time,
                  y: chartData.temp,
                  name: "temp",
                  type: "scatter",
                  mode: "lines",
                  line: {
                    width: 2,
                    color: "#F148FB",
                  },
                  yaxis: "y2",
                },
              ];
              this.drawDualAxisLineChart(charId, tmpChart, "", "", "");
            }
          });
        }, 500);
      }
    },
    setDynamicMeasurementChart() {
      if (
        this.dynamicMeasurementDataAnalysisDatas &&
        this.dynamicMeasurementDataAnalysisDatas.length > 0
      ) {
        setTimeout((x) => {
          this.dynamicMeasurementDataAnalysisDatas.forEach((data) => {
            let chartData = data.chartData;
            if (chartData) {
              let ptpData = chartData.ptp_chart_data;
              let rmsData = chartData.rms_chart_data;

              let ptpCharId =
                data.deviceid +
                (data.channel ? "_" + data.channel : "") +
                "_ptp_chart";

              let tmpPtpChart = [
                {
                  x: ptpData.time,
                  y: ptpData.data,
                  name: "data",
                  type: "scatter",
                  mode: "lines",
                  line: {
                    width: 2,
                    color: "#009999",
                  },
                },
                {
                  x: ptpData.time,
                  y: ptpData.trend,
                  name: "trend",
                  type: "scatter",
                  mode: "lines",
                  line: {
                    width: 2,
                    color: "#9999CC",
                  },
                },
                {
                  x: ptpData.time,
                  y: ptpData.temp,
                  name: "temp",
                  type: "scatter",
                  mode: "lines",
                  line: {
                    width: 2,
                    color: "#F148FB",
                  },
                  yaxis: "y2",
                },
              ];
              this.drawDualAxisLineChart(ptpCharId, tmpPtpChart, "", "", "");

              let rmsCharId =
                data.deviceid +
                (data.channel ? "_" + data.channel : "") +
                "_rms_chart";
              let tmpRmsChart = [
                {
                  x: rmsData.time,
                  y: rmsData.data,
                  name: "data",
                  type: "scatter",
                  mode: "lines",
                  line: {
                    width: 2,
                    color: "#009999",
                  },
                },
                {
                  x: rmsData.time,
                  y: rmsData.trend,
                  name: "trend",
                  type: "scatter",
                  mode: "lines",
                  line: {
                    width: 2,
                    color: "#9999CC",
                  },
                },
                {
                  x: rmsData.time,
                  y: rmsData.temp,
                  name: "temp",
                  type: "scatter",
                  mode: "lines",
                  line: {
                    width: 2,
                    color: "#F148FB",
                  },
                  yaxis: "y2",
                },
              ];
              this.drawDualAxisLineChart(rmsCharId, tmpRmsChart, "", "", "");
            }
          });
        }, 500);
      }
    },
    getAnalDataHist(reqBody) {
      this.$http
        .post("/report/getAnalDataHist", reqBody, { timeout: 600000 })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            if (
              res.data.data.error_msg != null &&
              res.data.data.error_msg.length > 0
            ) {
              this.setAlertTitle();
              this.$bvModal
                .msgBoxOk(res.data.data.error_msg, this.getAlertOptions)
                .then((value) => {})
                .catch((err) => {
                  console.error(err);
                });
              return;
            }
            this.setAnalDataHist(res.data.data);
          } else {
            // this.setAlertTitle()
            // this.$bvModal.msgBoxOk('관리자에게 문의하세요.', this.getAlertOptions).then(value => {
            // }).catch(err => {
            //   console.error(err)
            // })
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setAnalDataHist(items) {
      let fftAvgChart = [];
      for (let i = 0; i < items.fft_avg.data.length; i++) {
        let item = items.fft_avg.data[i];

        fftAvgChart.push({
          x: item.x,
          y: item.y,
          name: item.name,
          type: "scatter",
          mode: "lines",
          line: { width: 1 },
        });
      }
      this.drawLineChart("fftAvgChart", fftAvgChart, {
        showlegend: false,
      });

      let fftPeakChart = [];
      for (let i = 0; i < items.fft_peak.data.length; i++) {
        let item = items.fft_peak.data[i];
        let date =
          item.x.substring(0, 4) +
          "-" +
          item.x.substring(4, 6) +
          "-" +
          item.x.substring(6);

        fftPeakChart.push({
          x: [date],
          y: [item.y],
          type: "scatter",
          mode: "markers",
          marker: {
            size: 8,
            color: item.color,
          },
        });
      }
      this.drawDateChart("fftPeakChart", fftPeakChart, {
        showlegend: false,
      });

      this.fftClStatGridOptions.columnDefs = [
        { headerName: "Cluster #", field: "cluster_no" },
        { headerName: "Mean(Hz)", field: "freq_mean" },
        { headerName: "STD(Hz)", field: "freq_std" },
        { headerName: "MAX(Hz)", field: "freq_max" },
        { headerName: "MIN(Hz)", field: "freq_min" },
        { headerName: "Mean(Amplitude)", field: "amp_mean" },
        { headerName: "STD(Amplitude)", field: "amp_std" },
        { headerName: "MAX(Amplitude)", field: "amp_max" },
        { headerName: "MIN(Amplitude)", field: "amp_min" },
      ];
      this.fftClStatGridOptions.api.setColumnDefs(
        this.fftClStatGridOptions.columnDefs
      );
      this.fftClStatGridOptions.api.setRowData(items.fft_cl_stat);

      let ssiFreqChart = [];
      if (items.ssi_freq_chart && items.ssi_freq_chart.data.length > 0) {
        for (let i = 0; i < items.ssi_freq_chart.data.length; i++) {
          let item = items.ssi_freq_chart.data[i];
          let date =
            item.x.substring(0, 4) +
            "-" +
            item.x.substring(4, 6) +
            "-" +
            item.x.substring(6);

          ssiFreqChart.push({
            x: [date],
            y: [item.y],
            type: "scatter",
            mode: "markers",
            marker: {
              size: 8,
              color: item.color,
            },
          });
        }
        this.drawDateChart("ssiFreqChart", ssiFreqChart, {
          showlegend: false,
        });
      }

      this.ssiClStatGridOptions.columnDefs = [
        { headerName: "Cluster #", field: "cluster_no" },
        { headerName: "Mean(Hz)", field: "freq_mean" },
        { headerName: "STD(Hz)", field: "freq_std" },
        { headerName: "MAX(Hz)", field: "freq_max" },
        { headerName: "MIN(Hz)", field: "freq_min" },
        { headerName: "Mean(Damping coef)", field: "damping_mean" },
        { headerName: "STD(Damping coef)", field: "damping_std" },
        { headerName: "MAX(Damping coef)", field: "damping_max" },
        { headerName: "MIN(Damping coef)", field: "damping_min" },
      ];
      this.ssiClStatGridOptions.api.setColumnDefs(
        this.ssiClStatGridOptions.columnDefs
      );
      this.ssiClStatGridOptions.api.setRowData(items.ssi_cl_stat);

      let ssiIfChart = [];
      if (
        items.ssi_if &&
        items.ssi_if.init_data &&
        items.ssi_if.init_data.y.length > 0
      ) {
        for (let i = 0; i < items.ssi_if.init_data.y.length; i++) {
          let item = items.ssi_if.init_data.y[i];

          ssiIfChart.push({
            x: items.ssi_if.init_data.x,
            y: item.data,
            name: item.name,
            type: "scatter",
            mode: "lines",
            line: { width: 1 },
          });
        }
      }

      ssiIfChart.push({
        x: [],
        y: [],
        type: "scatter",
        mode: "markers",
        marker: {
          size: 8,
        },
      });

      if (items.ssi_if && items.ssi_if.data.length > 0) {
        for (let i = 0; i < items.ssi_if.data.length; i++) {
          let item = items.ssi_if.data[i];
          ssiIfChart[ssiIfChart.length - 1].x.push(item.x);
          ssiIfChart[ssiIfChart.length - 1].y.push(item.y);
        }
      }

      this.drawDualChart("ssiIfChart", ssiIfChart, {
        showlegend: false,
      });

      let ssiIfHist = [
        {
          x: [],
          y: [],
          type: "scatter",
          mode: "lines+markers",
          line: { width: 1 },
          marker: {
            size: 8,
          },
        },
      ];

      if (items.ssi_if_hist && items.ssi_if_hist.length > 0) {
        for (let i = 0; i < items.ssi_if_hist.length; i++) {
          let item = items.ssi_if_hist[i];
          let date =
            item.x.substring(0, 4) +
            "-" +
            item.x.substring(4, 6) +
            "-" +
            item.x.substring(6);
          ssiIfHist[0].x.push(date);
          ssiIfHist[0].y.push(item.y);
        }
      }
      this.drawDateChart("ssiIfHist", ssiIfHist, {
        showlegend: false,
      });
    },
    getInspectionAndAction(reqBody) {
      this.$http
        .post("/report/getInspectionAndAction", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            if (res.data.data && res.data.data.length > 0) {
              this.isStaticInspectionAndAction = true;

              this.staticInspectionAndActionGridOptions.columnDefs = [
                { headerName: "시작일", field: "compstdate", width: 150 },
                { headerName: "종료일", field: "compeddate", width: 150 },
                { headerName: "점검 내역", field: "compcheckdetail" },
              ];
              this.staticInspectionAndActionGridOptions.api.setColumnDefs(
                this.staticInspectionAndActionGridOptions.columnDefs
              );
              this.staticInspectionAndActionGridOptions.api.setRowData(
                res.data.data
              );
            }
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    drawLineChart(id, dataArr, param, range) {
      var data = dataArr;
      var layout = chartUtil.setDefaultLayout(id);
      layout.margin = {
        l:
          utils.chkNull(param.annotation) !== null &&
          utils.chkNull(param.annotation.yaxis) !== null
            ? 80
            : 50,
        r: utils.chkNull(param.showlegend, true) ? 80 : 50,
        t: 20,
        b: 30,
        pad: 0,
      };
      layout.showlegend = utils.chkNull(param.showlegend, true);
      if (utils.chkNull(range) !== null) {
        if (
          utils.chkNull(range.x) !== null &&
          (range.x.min !== 0 || range.x.max !== 0)
        ) {
          layout.xaxis.range = [range.x.min, range.x.max];
        }
        if (
          utils.chkNull(range.y) !== null &&
          (range.y.min !== 0 || range.y.max !== 0)
        ) {
          layout.yaxis.range = [range.y.min, range.y.max];
        }
      }
      layout.xaxis.color = "#666";
      layout.yaxis.color = "#666";
      layout.paper_bgcolor = "#fff";
      layout.plot_bgcolor = "#fff";
      layout.xaxis.tickfont.size = 9;
      layout.yaxis.tickfont.size = 9;
      Plotly.newPlot(id, data, layout);
    },
    drawDateChart(id, dataArr, param) {
      var data = dataArr;
      var layout = chartUtil.setDefaultDateLayout(id);
      layout.margin = {
        l:
          utils.chkNull(param.annotation) !== null &&
          utils.chkNull(param.annotation.yaxis) !== null
            ? 80
            : 50,
        r: utils.chkNull(param.showlegend, true) ? 80 : 50,
        t: 20,
        b: 30,
        pad: 0,
      };
      layout.showlegend = utils.chkNull(param.showlegend, true);
      layout.xaxis.color = "#666";
      layout.yaxis.color = "#666";
      layout.paper_bgcolor = "#fff";
      layout.plot_bgcolor = "#fff";
      layout.xaxis.tickfont.size = 9;
      layout.yaxis.tickfont.size = 9;
      Plotly.newPlot(id, data, layout);
    },
    drawDualChart(id, dataArr, param, range) {
      var data = dataArr;
      var layout = chartUtil.setDualAxisLayout(id, {
        datacnt:
          dataArr[0].x != null && dataArr[0].x.length > 0
            ? dataArr[0].x.length
            : dataArr[0].y.length,
        showxaxiscnt: 4,
        annotation: param.annotation,
      });
      layout.margin = {
        l:
          utils.chkNull(param.annotation) !== null &&
          utils.chkNull(param.annotation.yaxis) !== null
            ? 80
            : 50,
        r: utils.chkNull(param.showlegend, true) ? 80 : 50,
        t: 20,
        b: 30,
        pad: 0,
      };
      layout.showlegend = utils.chkNull(param.showlegend, true);
      if (utils.chkNull(range) !== null) {
        if (
          utils.chkNull(range.x) !== null &&
          (range.x.min !== 0 || range.x.max !== 0)
        ) {
          layout.xaxis.range = [range.x.min, range.x.max];
        }
        if (
          utils.chkNull(range.y) !== null &&
          (range.y.min !== 0 || range.y.max !== 0)
        ) {
          layout.yaxis.range = [range.y.min, range.y.max];
        }
        if (
          utils.chkNull(range.y2) !== null &&
          (range.y2.min !== 0 || range.y2.max !== 0)
        ) {
          layout.yaxis2.range = [range.y2.min, range.y2.max];
        }
      }
      layout.xaxis.color = "#666";
      layout.yaxis.color = "#666";
      layout.yaxis2.color = "#666";
      layout.paper_bgcolor = "#fff";
      layout.plot_bgcolor = "#fff";
      layout.xaxis.tickfont.size = 9;
      layout.yaxis.tickfont.size = 9;
      layout.yaxis2.tickfont.size = 9;
      Plotly.newPlot(id, data, layout);
    },
    drawDualAxisLineChart(id, datas, title, yText, y2Text) {
      let layout = chartUtil.setDualAxisDateLayout(id, {
        annotation: {
          xaxis: {
            text: title,
            color: "#666",
            fontSize: 13,
            x: 0.5,
            y: 1.16,
          },
          yaxis: {
            text: yText != null ? yText : "Data Size(MB)",
            color: "#666",
            fontSize: 13,
            x: -0.1,
            y: 0.5,
          },
          yaxis2: {
            text: y2Text != null ? y2Text : "Data Count",
            color: "#666",
            fontSize: 13,
            x: 1.1,
            y: 0.5,
          },
        },
        showlegend: true,
        margin: {
          l: 80,
          r: 80,
          t: 40,
          b: 30,
          pad: 0,
        },
        legend: {
          orientation: "h",
          x: 0.4,
          y: -0.15,
          font: {
            color: "#666",
            size: 9,
          },
        },
      });
      layout.xaxis.color = "#666";
      layout.yaxis.color = "#666";
      layout.yaxis2.color = "#666";
      layout.paper_bgcolor = "#fff";
      layout.plot_bgcolor = "#fff";
      layout.xaxis.tickfont.size = 9;
      layout.yaxis.tickfont.size = 9;
      layout.yaxis2.tickfont.size = 9;

      Plotly.newPlot(id, datas, layout);
    },
    async downloadPdf() {
      this.LoadYn = true;

      if (this.search.reportType === "weekly") {
        this.downloadWeeklyReportPdf();
      } else {
        this.downloadRailMonthReportPdf();
      }
    },
    async downloadWeeklyReportPdf() {
      window.html2canvas = html2canvas;
      let pdf = new JsPDF("p", "mm", "a4");
      let canvas = pdf.canvas;
      let pageWidth = 210;
      let pageHeight = pageWidth * 1.414;
      canvas.width = pageWidth;

      let headerEle = document.querySelector("#pdfHeaderDiv");
      let headerWidth = headerEle.offsetWidth;
      let headerHeight = headerEle.offsetHeight;
      let headerImgHeight = (pageWidth * headerHeight) / headerWidth;

      await this.getPdfHeaderImg();
      if (!this.pdf.headerImgData) {
        console.error("pdf header 만들기 실패.");
        this.LoadYn = false;
        return false;
      }

      let footerEle = document.querySelector("#pdfFooterDiv");
      let footerWidth = footerEle.offsetWidth;
      let footerHeight = footerEle.offsetHeight;
      let footerImgHeight = (pageWidth * footerHeight) / footerWidth;

      let bodyEle1 = document.querySelector("#pdfBodyDiv1");
      let bodyWidth1 = bodyEle1.offsetWidth;
      let bodyHeight1 = bodyEle1.offsetHeight;
      let bodyImgHeight1 = (pageWidth * bodyHeight1) / bodyWidth1;
      this.pdf.bodyImgDatas.push({
        imgData: null,
        imgHeight: bodyImgHeight1,
      });
      this.footer.totalPage += Math.ceil(
        bodyImgHeight1 / (pageHeight - headerImgHeight - footerImgHeight)
      );

      await this.getPdfBodyImg("#pdfBodyDiv1");
      if (!this.pdf.bodyImgDatas[this.pdf.bodyImgDatas.length - 1].imgData) {
        console.error("pdf body 만들기 실패.(idx: 1)");
        this.LoadYn = false;
        return false;
      }

      let bodyEle2 = document.querySelector("#pdfBodyDiv2");
      let bodyWidth2 = bodyEle2.offsetWidth;
      let bodyHeight2 = bodyEle2.offsetHeight;
      let bodyImgHeight2 = (pageWidth * bodyHeight2) / bodyWidth2;
      this.pdf.bodyImgDatas.push({
        imgData: null,
        imgHeight: bodyImgHeight2,
      });
      this.footer.totalPage += Math.ceil(
        bodyImgHeight2 / (pageHeight - headerImgHeight - footerImgHeight)
      );

      await this.getPdfBodyImg("#pdfBodyDiv2");
      if (!this.pdf.bodyImgDatas[this.pdf.bodyImgDatas.length - 1].imgData) {
        console.error("pdf body 만들기 실패.(idx: 2)");
        this.LoadYn = false;
        return false;
      }

      if (this.isSensorTypeDynamic) {
        for (
          let i = 0;
          i < this.dynamicMeasurementDataAnalysisDatas.length;
          i++
        ) {
          let bodyEle31Dynamic = document.querySelector(
            "#pdfBodyDiv3-1-" + i + "_dynamic"
          );
          let bodyWidth31Dynamic = bodyEle31Dynamic.offsetWidth;
          let bodyHeight31Dynamic = bodyEle31Dynamic.offsetHeight;
          let bodyImgHeight31Dynamic =
            (pageWidth * bodyHeight31Dynamic) / bodyWidth31Dynamic;
          this.pdf.bodyImgDatas.push({
            imgData: null,
            imgHeight: bodyImgHeight31Dynamic,
          });
          this.footer.totalPage += Math.ceil(
            bodyImgHeight31Dynamic /
              (pageHeight - headerImgHeight - footerImgHeight)
          );

          await this.getPdfBodyImg("#pdfBodyDiv3-1-" + i + "_dynamic");
          if (
            !this.pdf.bodyImgDatas[this.pdf.bodyImgDatas.length - 1].imgData
          ) {
            console.error("pdf body 만들기 실패.(idx: 3-1-" + i + "-dynamic)");
            this.LoadYn = false;
            return false;
          }
        }

        let bodyEle32Dynamic = document.querySelector("#pdfBodyDiv3-2_dynamic");
        let bodyWidth32Dynamic = bodyEle32Dynamic.offsetWidth;
        let bodyHeight32Dynamic = bodyEle32Dynamic.offsetHeight;
        let bodyImgHeight32Dynamic =
          (pageWidth * bodyHeight32Dynamic) / bodyWidth32Dynamic;
        this.pdf.bodyImgDatas.push({
          imgData: null,
          imgHeight: bodyImgHeight32Dynamic,
        });
        this.footer.totalPage += Math.ceil(
          bodyImgHeight32Dynamic /
            (pageHeight - headerImgHeight - footerImgHeight)
        );

        await this.getPdfBodyImg("#pdfBodyDiv3-2_dynamic");
        if (!this.pdf.bodyImgDatas[this.pdf.bodyImgDatas.length - 1].imgData) {
          console.error("pdf body 만들기 실패.(idx: 3-2-dynamic)");
          this.LoadYn = false;
          return false;
        }

        let bodyEle33Dynamic = document.querySelector("#pdfBodyDiv3-3_dynamic");
        let bodyWidth33Dynamic = bodyEle33Dynamic.offsetWidth;
        let bodyHeight33Dynamic = bodyEle33Dynamic.offsetHeight;
        let bodyImgHeight33Dynamic =
          (pageWidth * bodyHeight33Dynamic) / bodyWidth33Dynamic;
        this.pdf.bodyImgDatas.push({
          imgData: null,
          imgHeight: bodyImgHeight33Dynamic,
        });
        this.footer.totalPage += Math.ceil(
          bodyImgHeight33Dynamic /
            (pageHeight - headerImgHeight - footerImgHeight)
        );

        await this.getPdfBodyImg("#pdfBodyDiv3-3_dynamic");
        if (!this.pdf.bodyImgDatas[this.pdf.bodyImgDatas.length - 1].imgData) {
          console.error("pdf body 만들기 실패.(idx: 3-3-dynamic)");
          this.LoadYn = false;
          return false;
        }
      } else {
        let bodyEle31Static = document.querySelector("#pdfBodyDiv3-1_static");
        let bodyWidth31Static = bodyEle31Static.offsetWidth;
        let bodyHeight31Static = bodyEle31Static.offsetHeight;
        let bodyImgHeight31Static =
          (pageWidth * bodyHeight31Static) / bodyWidth31Static;
        this.pdf.bodyImgDatas.push({
          imgData: null,
          imgHeight: bodyImgHeight31Static,
        });
        this.footer.totalPage += Math.ceil(
          bodyImgHeight31Static /
            (pageHeight - headerImgHeight - footerImgHeight)
        );

        await this.getPdfBodyImg("#pdfBodyDiv3-1_static");
        if (!this.pdf.bodyImgDatas[this.pdf.bodyImgDatas.length - 1].imgData) {
          console.error("pdf body 만들기 실패.(idx: 3-1-static)");
          this.LoadYn = false;
          return false;
        }

        for (
          let i = 0;
          i < this.staticMeasurementDataAnalysisCustomerDatas.length;
          i++
        ) {
          let bodyEle32Static = document.querySelector(
            "#pdfBodyDiv3-2-" + i + "_static"
          );
          let bodyWidth32Static = bodyEle32Static.offsetWidth;
          let bodyHeight32Static = bodyEle32Static.offsetHeight;
          let bodyImgHeight32Static =
            (pageWidth * bodyHeight32Static) / bodyWidth32Static;
          this.pdf.bodyImgDatas.push({
            imgData: null,
            imgHeight: bodyImgHeight32Static,
          });
          this.footer.totalPage += Math.ceil(
            bodyImgHeight32Static /
              (pageHeight - headerImgHeight - footerImgHeight)
          );

          await this.getPdfBodyImg("#pdfBodyDiv3-2-" + i + "_static");
          if (
            !this.pdf.bodyImgDatas[this.pdf.bodyImgDatas.length - 1].imgData
          ) {
            console.error("pdf body 만들기 실패.(idx: 3-2-" + i + "-static)");
            this.LoadYn = false;
            return false;
          }
        }
      }

      let bodyEle4 = document.querySelector("#pdfBodyDiv4");
      let bodyWidth4 = bodyEle4.offsetWidth;
      let bodyHeight4 = bodyEle4.offsetHeight;
      let bodyImgHeight4 = (pageWidth * bodyHeight4) / bodyWidth4;
      this.pdf.bodyImgDatas.push({
        imgData: null,
        imgHeight: bodyImgHeight4,
      });
      this.footer.totalPage += Math.ceil(
        bodyImgHeight4 / (pageHeight - headerImgHeight - footerImgHeight)
      );

      await this.getPdfBodyImg("#pdfBodyDiv4");
      if (!this.pdf.bodyImgDatas[this.pdf.bodyImgDatas.length - 1].imgData) {
        console.error("pdf body 만들기 실패.(idx: 4)");
        this.LoadYn = false;
        return false;
      }

      let isSuccessed = true;
      for (let i = 0; i < this.pdf.bodyImgDatas.length; i++) {
        await this.getPdfFooterImg();
        if (!this.pdf.footerImgData) {
          console.error("pdf footer 만들기 실패.");
          this.LoadYn = false;
          return false;
        }

        let bodyImgData = this.pdf.bodyImgDatas[i];
        let heightLeft = bodyImgData.imgHeight;

        let position = 0;
        if (i > 0) {
          pdf.addPage();
        }
        pdf.addImage(
          this.pdf.headerImgData,
          "PNG",
          0,
          0,
          pageWidth,
          headerImgHeight
        );
        pdf.addImage(
          bodyImgData.imgData,
          "PNG",
          0,
          headerImgHeight,
          pageWidth,
          bodyImgData.imgHeight
        );
        pdf.addImage(
          this.pdf.footerImgData,
          "PNG",
          0,
          pageHeight - footerImgHeight,
          pageWidth,
          footerImgHeight
        );

        heightLeft -= pageHeight - headerImgHeight - footerImgHeight;
        while (heightLeft > 0) {
          await this.getPdfFooterImg();
          if (!this.pdf.footerImgData) {
            console.error("pdf footer 만들기 실패.");
            isSuccessed = false;
            break;
          }
          position = heightLeft - bodyImgData.imgHeight + headerImgHeight;

          pdf.addPage();
          pdf.addImage(
            bodyImgData.imgData,
            "PNG",
            0,
            position,
            pageWidth,
            bodyImgData.imgHeight
          );
          pdf.addImage(
            this.pdf.headerImgData,
            "PNG",
            0,
            0,
            pageWidth,
            headerImgHeight
          );
          pdf.addImage(
            this.pdf.footerImgData,
            "PNG",
            0,
            pageHeight - footerImgHeight,
            pageWidth,
            footerImgHeight
          );

          heightLeft -= pageHeight - headerImgHeight - footerImgHeight;
        }
      }

      if (isSuccessed) {
        pdf.save("its_report.pdf");
      }
      this.pdf.headerImgData = null;
      this.pdf.bodyImgDatas = [];
      this.pdf.footerImgData = null;
      this.footer.page = 1;
      this.footer.totalPage = 0;
      this.LoadYn = false;
    },
    downloadRailMonthReportPdf() {
      let reqBody = {
        fileName: this.pdfFileName,
        reportType: this.search.reportType,
        createDate: moment().format("YYYYMMDD"),
      };
      this.$http
        .post("/excelReport/downloadPdfFile", reqBody, {
          responseType: "arraybuffer",
        })
        .then((res) => {
          this.LoadYn = false;

          let url = window.URL.createObjectURL(
            new Blob([res.data], { type: res.headers["content-type"] })
          );
          let fileName = this.pdfFileName;
          let link = document.createElement("a");
          link.href = url;

          link.download = fileName;
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          this.LoadYn = false;
          console.error(err);
        });
    },
    getPdfHeaderImg() {
      let ele = document.querySelector("#pdfHeaderDiv");
      return new Promise((resolve, reject) => {
        html2canvas(ele)
          .then((canvas) => {
            this.pdf.headerImgData = canvas.toDataURL("image/png");
            resolve(this.pdf.headerImgData);
          })
          .catch((error) => {
            console.error(error);
          });
      });
    },
    getPdfBodyImg(target) {
      let ele = document.querySelector(target);
      return new Promise((resolve, reject) => {
        html2canvas(ele)
          .then((canvas) => {
            this.pdf.bodyImgDatas[this.pdf.bodyImgDatas.length - 1].imgData =
              canvas.toDataURL("image/png");
            resolve(
              this.pdf.bodyImgDatas[this.pdf.bodyImgDatas.length - 1].imgData
            );
          })
          .catch((error) => {
            console.error(error);
          });
      });
    },
    getPdfFooterImg() {
      ++this.footer.page;
      let ele = document.querySelector("#pdfFooterDiv");
      return new Promise((resolve, reject) => {
        html2canvas(ele)
          .then((canvas) => {
            this.pdf.footerImgData = canvas.toDataURL("image/png");
            resolve(this.pdf.footerImgData);
          })
          .catch((error) => {
            console.error(error);
          });
      });
    },
  },
};
</script>

<style lang="scss">
#report {
  padding: 15px;
  & .card {
    & .card-header {
      padding: 10px 15px;
      & h6 {
        font-size: 14px;
        line-height: unset;
        & label.autoRefresh {
          position: absolute;
          top: 7px;
          right: 92px;
          margin-bottom: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 24px;
        }
        & select.autoRefresh {
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 7px;
          right: 7px;
          width: 75px;
          height: 25px;
          padding: 0px 28px 1px 12px;
          border: 1px solid #404656;
          border-radius: 5px;
        }
      }
    }
  }
  & .searchBox {
    justify-content: space-between;
  }
  @media (max-width: 1950px) {
    & .searchBox {
      justify-content: space-between;
      border-radius: 10px;
      padding: 15px;
      margin-bottom: 15px;
      height: auto !important;
      box-sizing: border-box;

      .searchRows {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: auto;

        .searchRow {
          display: flex;
          flex-direction: row;
          width: 100%;
          height: auto;
          margin-bottom: 10px;
        }
        .search-item {
          margin-right: 20px;
          display: flex;
          flex-direction: row;
        }
        .search-item-group {
          display: flex;
          align-items: center;
        }
      }
    }

    & .body {
      height: calc(100vh - 300px);
    }
  }
  @media (min-width: 1951px) {
    & .searchBox {
      justify-content: space-between;
      border-radius: 10px;
      padding: 15px;
      margin-bottom: 15px;
      height: auto !important;
      box-sizing: border-box;

      .searchRows {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: auto;

        .searchRow {
          display: flex;
          flex-direction: row;
          width: 100%;
          height: auto;
          margin-bottom: 10px;
        }

        .search-item {
          margin-right: 20px;
          display: flex;
          flex-direction: row;
        }
        .search-item-group {
          display: flex;
          align-items: center;
        }
      }
    }
    & .body {
      height: calc(100vh - 300px);
    }
  }
  & .time {
    background-color: #283046;
    color: #b4b7bd !important;
    border: 1px solid #404656;
    border-radius: 5px;
    display: inline-flex;
    height: 100%;

    & input {
      border: none;
      background-color: #283046;
      color: #b4b7bd !important;
      text-align: center;
      width: 60px;
    }
  }
  & div.ag-theme-balham.grid {
    background-color: #ffffff00 !important;
    & .ag-root .ag-body .ag-body-viewport {
      overflow-x: hidden;
    }
  }
  & .ag-theme-balham .ag-root .ag-header {
    background-color: #3a3f42 !important;
  }
  & .ag-theme-balham .ag-root .ag-body .ag-row.ag-row-even {
    background-color: #ffffff00 !important;
    color: #000;
    font-weight: bold;
  }
  & .ag-theme-balham .ag-root .ag-body .ag-row.ag-row-odd {
    background-color: #ffffff00 !important;
    color: #000;
    font-weight: bold;
  }
  &
    .ag-theme-balham
    .ag-root
    .ag-header
    .ag-header-row
    .ag-header-group-cell-label
    span,
  .ag-theme-balham
    .ag-root
    .ag-header
    .ag-header-row
    .ag-header-cell-label
    .ag-header-cell-text {
    padding-left: 0px !important;
    font-size: 7pt !important;
  }
  & .ag-theme-balham .ag-root .ag-body .ag-row .ag-cell {
    font-size: 7pt !important;
  }
  & .body {
    overflow-y: auto;

    .weeklyReportDiv {
      display: grid;
      justify-content: center;

      .a4 {
        display: flex;
        flex-direction: column;
        width: 21cm;
        color: #666;
        font-size: 20px;
        background-color: #fff;
        // margin-bottom: 1px;
        font-family: "Noto Sans KR";
        padding: 10px;

        .header {
          position: relative;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          height: 50px;
          line-height: 50px;
          font-size: 14pt;
          font-weight: bold;

          .logo {
            position: absolute;
            left: 0;
            top: 0;
          }

          .date {
            position: absolute;
            right: 0;
            top: 0;
            width: auto;
            white-space: nowrap;
            font-size: 8pt;
            line-height: 10px;
            font-style: italic;
          }
        }

        .title {
          color: #555;
          font-size: 12pt;
          font-weight: bold;
          margin-bottom: 15px;
        }

        .content {
          margin-bottom: 15px;
          font-size: 10pt;
          font-weight: bold;

          .key {
            height: 20px;
          }

          .ml30 {
            margin-left: 30px;
          }

          .ml45 {
            margin-left: 45px;
          }

          .ml55 {
            margin-left: 55px;
          }

          .chart {
            height: 250px;
          }

          textarea {
            width: 100%;
            min-height: 100px;
          }

          .customer-textarea {
            width: 100%;
            min-height: 100px;
            border: 1px solid #767676;
            border-radius: 3px;
            padding: 5px;
          }
        }

        .footer {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          height: 30px;
          line-height: 30px;
          font-size: 15px;
          font-weight: bold;
          font-style: italic;
        }

        .highlight-text-blue-color {
          color: #ff0000;
        }

        .highlight-text-blue-color {
          color: #0000ff;
        }

        .highlight-text-black-color {
          color: #000;
        }

        .highlight-text-orange-color {
          color: #ffa500;
        }
      }
    }

    .pdfViewDiv {
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/Report.vue